<template lang="pug">
  .google-map-container
    slot
</template>

<script>
  export default {
    name: 'GoogleMapContainer'
  }
</script>

<style lang="sass">
  .google-map-container
    .google-map
      min-height: 500px
      min-width: 500px
</style>



// WEBPACK FOOTER //
// GoogleMapContainer.vue?a9584458